let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8mKjW")).then(() => parcelRequire('1ThzG'));